
import Card from "@mui/material/Card";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
// Material Dashboard 2 React example components
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import DataTable from "layouts/Tables/DataTable";
//import projectsTableData from "layouts/tables/data/projectsTableData";
import Config from "../../config.js";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from 'react-toastify';
import "rsuite/dist/rsuite.min.css";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import { CircularProgress, Backdrop } from "@mui/material";
import { handleErrors, checkPrivilege } from "common.js";
import { PRIVILEGE, CATEGORY } from "constants.js";

function ManageCategories(props) {

  const type = props.props.type;
  const navigate = useNavigate();
  const { pid } = useParams();
  const { t } = useTranslation();
  const BASE = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [categoryData, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const adminType = localStorage.getItem("type");

  const changeStatus = async (id) => {
    axios({
      url: BASE + "api/category/remove/" + id + '/' + type,
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
      // Attaching the form data
    }).then(function (response) { 
      setIsLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          toast.success(t(message))
          const updatedRows = categoryData.data.rows.filter((row) => row.id !== id);
        setData({
          ...data,
          data: {
            ...data.data,
            rows: updatedRows
          }
        });        
        }
        else {
          if (message != '')
            toast.error(t(message))
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch((error) => {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  }

  const data = () => {
    axios({
      // Endpoint to send files
      url: BASE + "api/category/list",
      method: "POST",
      data: { "parentId": (pid == undefined) ? 0 : pid, "type": type },
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
      // Attaching the form data
    }).then(function (response) {
      setIsLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          setData(response.data);      
        }
        else {
          if (message != '')
            toast.error(t(message))
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    })
      .catch(function (error) {
        setIsLoading(false);
        handleErrors(error, t, navigate);
      });
  }

  useEffect(() => {
    data();
  }, [pid, type]);

  const columns = [
    { Header: t("id"), accessor: "id", align: "left" },
    { Header: t("name"), accessor: "name", align: "left" },
    { Header: t("handle"), accessor: "handle", align: "left" },
    { Header: t("categoryId"), accessor: "collectionId", align: "left" },
    { Header: t("tagName"), accessor: "tagName", align: "left" },
    { Header: t("action"), accessor: "action", align: "left" }
  ];

  const finalObj = [];
  const finalNav = [];

  for (let key in categoryData.data) {
    if (key == 'rows') {
      categoryData.data[key].map(function (val, index) {
        let serviceType = (type == CATEGORY.PRODUCT) ? 'productCategory' : 'serviceCategory';
        let tempObj = {
          id: "#" + val.id, name: (val.childCount > 0) ? (<Link to={'/' + serviceType + '/list/' + val.id}>{val.name}</Link>) : (val.name),
          handle: val.handle, collectionId: val.collectionId, tagName: (val.tagName) ? val.tagName : t('na'),
          action:
            <span className="actionLinksStyle">
              {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && (checkPrivilege("category", "read") || checkPrivilege("category", "write")))) ?
                <MDTypography component="a" href={'#'} onClick={(event) => { event.preventDefault(); navigate("/" + serviceType + "/edit/" + val.id + '/' + type) }} variant="caption" color="text" fontWeight="medium">
                  <Tooltip title={t('edit')}><Box className="ActionEdit paddingRight5"><EditIcon /></Box></Tooltip>
                </MDTypography>
                : null
              }
              {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && (checkPrivilege("category", "delete")))) ?
                <MDTypography component="a" onClick={() => changeStatus(val.id)}><Tooltip title={t('delete')}><Box className="ActionDelete"><DeleteIcon /></Box></Tooltip></MDTypography>
                :
                null}
            </span>
        };
        finalObj.push(tempObj);
      })
    } else if (key == "parents") {
      finalNav.push(categoryData.data[key]);
      currentPageBreadcrumb = categoryData.data[key][0].name;
    }
  }

  const rows = finalObj;
  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={(type == CATEGORY.PRODUCT) ? t('productCategory') : (type == CATEGORY.SERVICE) ? t('serviceCategory') : null} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {(Object.keys(categoryData).length > 0) ?
        <MDBox pt={6} pb={3} >
          <Card>
            <MDBox pt={0} mt={5}>
              <>
                {(rows.length > 0) ?
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={{ defaultValue: 100 }}
                    showTotalEntries={false}
                    noEndBorder
                  />
                  : <MDBox pt={6} pb={3}><span className="noResult">{t('noResultFount')}</span></MDBox>
                }
              </>
            </MDBox>
          </Card>
        </MDBox>
        :
        null
      }
    </DashboardLayout>
  );
}

export default ManageCategories;
